import ActionButton from './actionButton'

type Props = {
  buttons: Array<{
    type: string
    title: string
    icon: string
    loading?: boolean
  }>
  isLoading?: boolean
  mutate: (...props: any) => void
}

const ActionButtons: React.FC<Props> = ({ buttons, isLoading }) => {
  return (
    <>
      {buttons?.map((item, index) => (
        <ActionButton
          {...{ ...item, loading: item.loading || isLoading }}
          key={index}
        />
      ))}
    </>
  )
}

export default ActionButtons
